import { render, staticRenderFns } from "./gradient.vue?vue&type=template&id=3f4caad6&"
import script from "./gradient.vue?vue&type=script&lang=js&"
export * from "./gradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports